import { createAction, props } from '@ngrx/store';
import { IIncomeData, IIncomeModel } from '@partners/api';

export class IncomeActions {
  static reset = createAction('[Income] Reset State');
  static load = createAction('[Income] Load');
  static loadSuccess = createAction('[Income] Load Success', props<{ model: IIncomeModel; data: IIncomeData }>());
  static loadFailure = createAction('[Income] Load Failure', props<{ error: any }>());
  static submit = createAction('[Income] Submit');
  static submitSuccess = createAction('[Income] Submit Success', props<{ model: IIncomeModel; data: IIncomeData }>());
  static submitFailure = createAction('[Income] Submit Failure', props<{ error: any }>());
}
